import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { withTranslation } from 'react-i18next'
import View from './internals/View'
import {
  upload as uploadPOST,
  updateAR
} from '../../../../services/api/library'
import { config, general } from '../../../../constants'

const ARUploads = ({
  editAssets,
  selectedData,
  distroyUnity,
  dispatchResult,
  upload,
  tab,
  hideModal,
  parent_id
}) => {
  const [state, setState] = useState({
    mediaDat: {},
    zipLoading: false,
    imgLoading: false,
    imgPreviewLoading: false,
    audioLoading: false,
    scaleMP4: '',
    scaleZip: 0.15,
    isZip: false,
    tempId: '',
    submitLoading: false,
    imageSizeCheck: false,
    isMarkerBased: 1,
    zipSizeCheck: false,
    deletedIndex: null
  })

  useEffect(() => {
    const { mediaDat } = state
    console.log('useEffect', selectedData)
    console.log('useEffect tab', tab)
    if (
      editAssets &&
      selectedData &&
      selectedData.id &&
      selectedData.ar_files
    ) {
      const found = selectedData.ar_files.some(
        el =>
          el.media_mime_type === 'application/zip' ||
          el.media_mime_type === 'application/x-zip-compressed'
      )
      console.log('found check didmount', found)
      setState(prevState => ({
        ...prevState,
        mediaDat: {
          ...mediaDat,
          id: selectedData.id,
          is_interactive: selectedData.is_interactive,
          ar_files: selectedData.ar_files,
          custom_data: selectedData.custom_data
        },
        isZip: !found ? false : true,
        isMarkerBased: !_.isEmpty(selectedData.custom_data.geoloc) ? 2 : 1
      }))
    }

    // SERVER WAKE CALL
    const GET_URL = `${config.phpServerURL}?select=GetTarget`
    fetch(GET_URL)
      .then(response => {
        return response.json()
      })
      .then(response => {
        console.log('PHP response GET', response)
      })
      .catch(error => {
        // handle the error
        console.log('ERROR GET', error)
      })
  }, [editAssets, selectedData])

  const onUnitySaveClicked = data => {
    setState(prevState => {
      console.log('Previous state in onUnitySaveClicked:', prevState)
      const { mediaDat = {}, isMarkerBased } = prevState
      console.log('mediaDat from prevState:', mediaDat)

      const parsedData = JSON.parse(data.json)
      console.log('Parsed data from unity:', parsedData)

      return {
        ...prevState,
        mediaDat: {
          ...mediaDat,
          is_interactive: true,
          ar_type: isMarkerBased === 2 ? 'geo' : 'marker',
          customData: {
            ...mediaDat.customData,
            unity_coordinates: parsedData
          }
        }
      }
    })
  }

  const onDropTargetImage = (acceptedFiles, rejectedFiles) => {
    const accepted_files = acceptedFiles[0]
    const rejected_files = rejectedFiles[0]

    if (rejected_files) {
      setState(prevState => ({
        ...prevState,
        imageSizeCheck: true
      }))
      return
    }

    fileReader(accepted_files, 'preview-img')
    setState(prevState => ({
      ...prevState,
      imgLoading: true,
      imageSizeCheck: false
    }))

    upload(accepted_files, { isAR: 'imgAR', parent_id: parent_id }, tab).then(value => {
      const { mediaDat } = state
      setState(prevState => ({
        ...prevState,
        mediaDat: {
          ...mediaDat,
          category: 'ar',
          key: value.key,
          filename: value.filename,
          type: value.type,
          format: 'ARIMAGE'
        },
        imgLoading: false
      }))
    })
  }

  const onDropppedZip = (acceptedFiles, rejectedFiles) => {
    const { mediaDat, isMarkerBased } = state
    const rejected_files = rejectedFiles[0]

    if (rejected_files) {
      console.log('i m rejected zip')
      setState(prevState => ({
        ...prevState,
        zipSizeCheck: true
      }))
      return
    }

    console.log('acceptedFiles Array', acceptedFiles)

    // For marker-based AR (isMarkerBased === 2), handle multiple files
    if (isMarkerBased === 2) {
      setState(prevState => ({
        ...prevState,
        zipLoading: true
      }))

      // Process each file sequentially
      const uploadFiles = async () => {
        const uploadedFiles = []

        for (const file of acceptedFiles) {
          try {
            const value = await upload(file, { isAR: 'zipAR' }, tab)
            uploadedFiles.push(value)
          } catch (error) {
            console.error('Error uploading file:', error)
          }
        }

        // Update state with all uploaded files
        setState(prevState => {
          const newFiles = uploadedFiles.map((value, index) => {
            // Get the corresponding geoloc item for this index
            const geolocItem =
              mediaDat.customData &&
                mediaDat.customData.geoloc &&
                Array.isArray(mediaDat.customData.geoloc) &&
                index < mediaDat.customData.geoloc.length
                ? mediaDat.customData.geoloc[index]
                : null

            return {
              filename: value.filename,
              media_format: value.type === 'video/mp4' ? 'VIDEO' : 'COMPRESSED',
              scale: null,
              id: value.id,
              key: value.key,
              media_mime_type: value.type,
              geo_id: geolocItem && geolocItem.index ? geolocItem.index : null
            }
          })

          return {
            ...prevState,
            mediaDat: {
              ...mediaDat,
              ar_files: mediaDat.hasOwnProperty('ar_files')
                ? [...mediaDat.ar_files, ...newFiles]
                : newFiles,
              ar_type: isMarkerBased === 2 ? 'geo' : 'marker'
            },
            zipLoading: false,
            isZip: true
          }
        })
      }

      uploadFiles()
      return
    }

    // Original single file upload logic for isMarkerBased === 1
    const accepted_files = acceptedFiles[0]
    if (accepted_files && accepted_files.type === 'video/mp4') {
      const video = document.createElement('video')
      video.addEventListener('loadedmetadata', () => {
        console.log('Video Width Height', video.videoWidth, video.videoHeight)
        if (mediaDat.hasOwnProperty('ar_files')) {
          let arFiles = mediaDat.ar_files.slice()
          const audioIndex =
            mediaDat &&
            mediaDat.ar_files &&
            arFiles.findIndex(obj => {
              return obj.media_format === 'AUDIO'
            })
          if (audioIndex > -1) {
            arFiles.splice(audioIndex, 1)
          }

          const compressId =
            mediaDat &&
            mediaDat.ar_files &&
            arFiles.find(obj => {
              return obj.media_format === 'COMPRESSED'
            })

          setState(prevState => ({
            ...prevState,
            tempId: compressId && compressId.id ? compressId.id : ''
          }))

          const compressIndex =
            mediaDat &&
            mediaDat.ar_files &&
            arFiles.findIndex(obj => {
              return obj.media_format === 'COMPRESSED'
            })

          if (compressIndex > -1) {
            arFiles.splice(compressIndex, 1)
          }

          console.log('arFiles after spliced', arFiles)
          setState(prevState => ({
            ...prevState,
            mediaDat: { ...mediaDat, ar_files: arFiles }
          }))
        }
        setState(prevState => ({
          ...prevState,
          scaleMP4: video.videoHeight / video.videoWidth,
          isZip: false
        }))
      })
      video.src = URL.createObjectURL(accepted_files)
    } else {
      setState(prevState => ({
        ...prevState,
        isZip: true
      }))

      if (mediaDat.hasOwnProperty('ar_files')) {
        let arFiles = mediaDat.ar_files.slice()

        const videoId =
          mediaDat &&
          mediaDat.ar_files &&
          arFiles.find(obj => {
            return obj.media_format === 'VIDEO'
          })

        setState(prevState => ({
          ...prevState,
          tempId: videoId && videoId.id ? videoId.id : ''
        }))

        const videoIndex =
          mediaDat &&
          mediaDat.ar_files &&
          arFiles.findIndex(obj => {
            return obj.media_format === 'VIDEO'
          })

        if (videoIndex > -1) {
          arFiles.splice(videoIndex, 1)
        }

        console.log('arFiles after spliced else', arFiles)
        setState(prevState => ({
          ...prevState,
          mediaDat: { ...mediaDat, ar_files: arFiles }
        }))
      }
    }

    setState(prevState => ({
      ...prevState,
      zipLoading: true
    }))

    console.log('accepted_files file for Zip ', accepted_files)

    upload(accepted_files, { isAR: 'zipAR', parent_id: parent_id }, tab).then(value => {
      const { tempId } = state
      const typeTemp = value.type === 'video/mp4' ? 'VIDEO' : 'COMPRESSED'
      console.log('tempId file ', tempId)
      const index = findIndex(typeTemp)
      if (tempId !== '') {
        value.id = tempId
      }
      console.log('value changed ', value)
      checkPoint(generateObject(typeTemp, value), index, 'zipLoading')
    })
  }

  const onDropTargetPreviewImage = (acceptedFiles, rejectedFiles) => {
    const accepted_files = acceptedFiles[0]
    const rejected_files = rejectedFiles[0]

    if (rejected_files) {
      console.log('i m rejected preview image')
      return
    }

    fileReader(accepted_files, 'preview-ar-img')
    setState(prevState => ({
      ...prevState,
      imgPreviewLoading: true
    }))

    upload(accepted_files, { isAR: 'zipAR', parent_id: parent_id }, tab).then(value => {
      console.log('VALUE CHECK PREVIEW', value)
      const index = findIndex('IMAGE')
      checkPoint(generateObject('IMAGE', value), index, 'imgPreviewLoading')
    })
  }

  const onDropppedAudio = (acceptedFiles, rejectedFiles) => {
    const accepted_files = acceptedFiles[0]
    const rejected_files = rejectedFiles[0]

    if (rejected_files) {
      console.log('i m rejected audio')
      return
    }

    setState(prevState => ({
      ...prevState,
      audioLoading: true
    }))

    upload(accepted_files, { isAR: 'zipAR', parent_id: parent_id }, tab).then(value => {
      console.log('VALUE CHECK AUDIO', value)
      const index = findIndex('AUDIO')
      checkPoint(generateObject('AUDIO', value), index, 'audioLoading')
    })
  }

  const fileReader = (f, t) => {
    const reader = new FileReader()
    reader.onload = () => {
      const output = document.getElementById(t)
      if (output) {
        output.src = reader.result
      }
    }
    reader.readAsDataURL(f)
  }

  const isType = data => {
    const index =
      data &&
      data.data &&
      data.data.ar_files &&
      data.data.ar_files.findIndex(obj => {
        return obj.media_format === 'COMPRESSED' || obj.media_format === 'VIDEO'
      })
    if (
      index > -1 &&
      data.data.ar_files[index].media_mime_type === 'video/mp4'
    ) {
      return 'mp4'
    } else {
      return 'zip'
    }
  }

  const resetState = () => {
    hideModal()
    setState({
      mediaDat: {},
      zipLoading: false,
      isZip: false,
      imgLoading: false,
      imgPreviewLoading: false,
      audioLoading: false,
      submitLoading: false,
      tempId: ''
    })
  }

  const onChangeZipScale = v => {
    console.log('inside onChangeZipScale', v)
    setState(prevState => ({
      ...prevState,
      scaleZip: v
    }))
  }

  const onChangeMarkerBased = e => {
    setState(prevState => ({
      ...prevState,
      isMarkerBased: e.target.value
    }))
  }

  const generateObject = (mediaFormat, val) => {
    console.log('log val', val)
    return {
      filename: val.filename,
      media_format: mediaFormat,
      scale: null,
      id: val.id,
      key: val.key,
      media_mime_type: val.type
    }
  }

  const findIndex = type => {
    const { mediaDat } = state
    return (
      mediaDat &&
      mediaDat.ar_files &&
      mediaDat.ar_files.findIndex(obj => {
        return obj.media_format === type
      })
    )
  }

  const checkPoint = (struct, index, loader) => {
    const { mediaDat } = state
    if (mediaDat.hasOwnProperty('ar_files')) {
      let arFiles = mediaDat.ar_files.slice()
      if (index > -1) {
        struct.id = arFiles[index].id
        arFiles[index] = struct
      } else {
        arFiles[arFiles.length] = struct
      }
      setState(prevState => ({
        ...prevState,
        mediaDat: { ...mediaDat, ar_files: arFiles },
        [loader]: false
      }))
    } else {
      setState(prevState => ({
        ...prevState,
        mediaDat: { ...mediaDat, ar_files: [struct] },
        [loader]: false
      }))
    }
  }

  const onChangeTitle = e => {
    if (!e) return

    const { mediaDat = {} } = state
    const value = e.target ? e.target.value.trim() : ''

    setState(prevState => ({
      ...prevState,
      mediaDat: {
        ...mediaDat,
        title: value
      }
    }))
  }

  const onChangeDescription = e => {
    if (!e) return

    const { mediaDat = {} } = state
    const value = e.target ? e.target.value : ''

    setState(prevState => ({
      ...prevState,
      mediaDat: { ...mediaDat, description: value }
    }))
  }

  const onDeleteMarker = deletedIndex => {
    console.log('onDeleteMarker called with index:', deletedIndex)
    console.log('Current state:', state)

    // Ensure we have the latest state
    setState(prevState => {
      console.log('Previous state in setState:', prevState)
      const { mediaDat } = prevState
      console.log('mediaDat from prevState:', mediaDat)

      // Initialize mediaDat if it's empty
      const initializedMediaDat = mediaDat || {
        customData: { geoloc: [] },
        ar_files: []
      }

      console.log('initializedMediaDat:', initializedMediaDat)

      // Update customData.geoloc by removing the specific index and reindexing
      const currentGeoloc =
        initializedMediaDat.customData && initializedMediaDat.customData.geoloc
      console.log('currentGeoloc before filter:', currentGeoloc)

      const updatedGeoloc = currentGeoloc
        ? currentGeoloc
          .filter((item, index) => {
            console.log(
              'filtering geoloc item',
              item,
              'index',
              index,
              'deletedIndex',
              deletedIndex
            )
            return index !== deletedIndex
          })
          .map((item, index) => {
            console.log('mapping geoloc item', item, 'to new index', index)
            return {
              ...item,
              index: index // Reindex to maintain sequential order
            }
          })
        : []

      console.log('updatedGeoloc after processing:', updatedGeoloc)

      // Update ar_files by removing the file with matching geo_id and updating remaining geo_id values
      const currentArFiles = initializedMediaDat.ar_files
      console.log('currentArFiles before filter:', currentArFiles)

      const updatedArFiles = currentArFiles
        ? currentArFiles
          .filter(file => {
            console.log(
              'filtering ar_file',
              file,
              'geo_id',
              file.geo_id,
              'deletedIndex',
              deletedIndex
            )
            return file.geo_id !== deletedIndex
          })
          .map(file => {
            // If the file's geo_id is greater than the deleted index, decrement it to match new geoloc indices
            if (file.geo_id > deletedIndex) {
              console.log(
                'updating ar_file geo_id',
                file.geo_id,
                'to',
                file.geo_id - 1
              )
              return {
                ...file,
                geo_id: file.geo_id - 1
              }
            }
            // If the file's geo_id is less than the deleted index, keep it as is
            console.log('keeping ar_file unchanged', file)
            return file
          })
        : []

      console.log('updatedArFiles after processing:', updatedArFiles)

      // Return the new state
      return {
        ...prevState,
        mediaDat: {
          ...initializedMediaDat,
          customData: {
            ...initializedMediaDat.customData,
            geoloc: updatedGeoloc
          },
          ar_files: updatedArFiles
        }
      }
    })
  }

  const onGeoLocation = e => {
    const { mediaDat } = state
    console.log('e onGeoLocation', e)
    console.log('mediaDat onGeoLocation', mediaDat)
    // First, create updated geoloc array with proper index values
    const updatedGeoloc = e.map((item, index) => ({
      ...item,
      index: index // Set index based on array position
    }))

    // Then, update ar_files with corresponding geo_id values, only for entries that have corresponding geoloc
    const updatedArFiles = mediaDat.ar_files
      ? mediaDat.ar_files.map((file, index) => {
        // Only update if there's a corresponding geoloc entry and the file doesn't already have a geo_id
        if (updatedGeoloc[index] && !file.geo_id) {
          return {
            ...file,
            geo_id: updatedGeoloc[index].index
          }
        }
        // Keep the original file if no corresponding geoloc entry or if it already has a geo_id
        return file
      })
      : []

    setState(prevState => ({
      ...prevState,
      mediaDat: {
        ...mediaDat,
        customData: {
          ...mediaDat.customData,
          geoloc: updatedGeoloc
        },
        ar_files: updatedArFiles
      }
    }))
  }

  const onClickUpdate = () => {
    setState(prevState => ({
      ...prevState,
      submitLoading: true
    }))

    const { mediaDat, scaleZip } = state

    const cIndex =
      mediaDat &&
      mediaDat.ar_files.findIndex(obj => {
        return obj.media_format === 'COMPRESSED'
      })
    let arFilesTemp = mediaDat.ar_files.slice()

    if (cIndex > -1) {
      arFilesTemp[cIndex].scale = scaleZip
    }

    setState(prevState => ({
      ...prevState,
      mediaDat: { ...mediaDat, ar_files: arFilesTemp }
    }))

    if (mediaDat && mediaDat.id) {
      updateAR(mediaDat, mediaDat.id).then(data => {
        console.log('UPDATE RETURN', data)
        const isTypeData = isType(data)
        console.log('log isTypeData update', isTypeData)
        if (
          data.data &&
          data.data.ar_files &&
          data.data.custom_data &&
          data.data.custom_data.target_id
        ) {
          const { scaleMP4 } = state
          const index = data.data.ar_files.findIndex(obj => {
            return (
              obj.media_format === 'COMPRESSED' || obj.media_format === 'VIDEO'
            )
          })

          console.log('log index update', index)

          const audioIndex = data.data.ar_files.findIndex(obj => {
            return obj.media_format === 'AUDIO'
          })

          const tempScaleMP4 =
            scaleMP4 !== '' ? scaleMP4 : data.data.custom_data.scaleMP4

          const UPDATE_URL = `${config.phpServerURL
            }?select=UpdateTarget&isType=${isTypeData}&mp4Scale=${tempScaleMP4}&scale=${data.data.ar_files[index].scale
            }&paramImg=${data.data.link}&targetId=${data.data.custom_data.target_id
            }&paramAudio=${audioIndex > -1 ? data.data.ar_files[audioIndex].link : null
            }&paramZip=${data.data.ar_files[index].link}`
          fetch(UPDATE_URL)
            .then(response => {
              return response.json()
            })
            .then(response => {
              console.log('PHP response update', response)
              dispatchResult(data.data)
              resetState()
            })
            .catch(error => {
              // handle the error
              console.log('UPDATE CATCH ERROR', error)
              dispatchResult(data.data)
              resetState()
            })
        } else {
          //@TODO Remove this later
          dispatchResult(data.data)
          resetState()
        }
      })
    }
  }

  const onClickSubmit = () => {
    const { mediaDat, scaleZip, isMarkerBased } = state
    console.log('mediaDat on onClickSubmit', mediaDat)
    const arFilesTemp =
      mediaDat && mediaDat.ar_files && mediaDat.ar_files.length > 0
        ? mediaDat.ar_files.map((item, index) => {
          if (isMarkerBased === 2) {
            return {
              ...item,
              scale: scaleZip,
              geo_id: index
            }
          }
          return {
            ...item,
            scale: scaleZip
          }
        })
        : []

    // First set submitLoading to true
    setState(prevState => ({
      ...prevState,
      submitLoading: true
    }))

    // Then update mediaDat with ar_files
    setState(prevState => ({
      ...prevState,
      mediaDat: {
        ...mediaDat,
        ar_files: arFilesTemp,
        ar_type: isMarkerBased === 2 ? 'geo' : 'marker'
      }
    }))

    console.log('mediaState before dispatch', mediaDat)
    if (tab && tab === general.PUBLIC_MEDIA) {
      mediaDat.status = 'public'
    } else if (tab && tab === general.MY_MEDIA) {
      mediaDat.status = 'private'
    } else if (tab && tab === general.ORGANIZATION_LIBRARY) {
      mediaDat.status = 'org'
    }
    mediaDat.parent_id = parent_id || null
    uploadPOST(mediaDat).then(data => {
      const isTypeData = isType(data)
      console.log('POST RETURN', data)
      if (data && data.data && data.data.ar_files) {
        const index = data.data.ar_files.findIndex(obj => {
          return (
            obj.media_format === 'COMPRESSED' || obj.media_format === 'VIDEO'
          )
        })

        const audioIndex = data.data.ar_files.findIndex(obj => {
          return obj.media_format === 'AUDIO'
        })

        // Skip the setTimeout block for marker-based AR
        if (isMarkerBased === 2) {
          console.log('Check data.data', data.data)
          dispatchResult(data.data)
          resetState()
          return
        }

        setTimeout(() => {
          const { scaleMP4 } = state

          // // Validate that we have a valid index for the video/compressed file
          // if (index === -1) {
          //   console.error('No video or compressed file found in ar_files')
          //   return
          // }

          const POST_URL = `${config.phpServerURL
            }?select=PostNewTarget&isType=${isTypeData}&mp4Scale=${scaleMP4}&scale=${data?.data?.ar_files[index]?.scale
            }&paramImg=${data?.data?.link}&paramAudio=${audioIndex > -1 ? data.data.ar_files[audioIndex].link : null
            }&paramZip=${data?.data?.ar_files[index]?.link}`
          fetch(POST_URL)
            .then(response => {
              return response.json()
            })
            .then(response => {
              console.log('PHP response check', response)
              let target_id = {
                customData: response
              }
              target_id.customData.geoloc = data?.data?.custom_data?.geoloc
              target_id.customData.unity_coordinates =
                data?.data?.custom_data?.unity_coordinates
              target_id.ar_type = isMarkerBased === 2 ? 'geo' : 'marker'
              target_id.ar_type = isMarkerBased === 2 ? 'geo' : 'marker'
              // @TODO
              if (response && response.result_code === 'TargetCreated') {
                if (scaleMP4 !== '') {
                  target_id.customData.scaleMP4 = scaleMP4
                }
                updateAR(target_id, data?.data?.id).then(value => {
                  console.log('UpdateAR logs: ', value)
                  dispatchResult(data.data)
                  resetState()
                })
              }
            })
            .catch(error => {
              // handle the error
              console.log('CREATE CATCH ERROR', error)
              dispatchResult(data.data)
              resetState()
            })
        }, 300)
      }
    })
  }

  console.log('ARUploads mediaDat', state.mediaDat)

  return (
    <View
      mediaDat={state.mediaDat}
      distroyUnity={distroyUnity}
      zipLoading={state.zipLoading}
      isMarkerBased={state.isMarkerBased}
      imgLoading={state.imgLoading}
      scaleMP4={state.scaleMP4}
      selectedData={selectedData}
      submitLoading={state.submitLoading}
      imgPreviewLoading={state.imgPreviewLoading}
      audioLoading={state.audioLoading}
      isZip={state.isZip}
      onChangeZipScale={onChangeZipScale}
      imageSizeCheck={state.imageSizeCheck}
      zipSizeCheck={state.zipSizeCheck}
      editAssets={editAssets}
      onChangeTitle={onChangeTitle}
      onChangeDescription={onChangeDescription}
      onDropTargetImage={onDropTargetImage}
      onDropppedZip={onDropppedZip}
      onDropppedAudio={onDropppedAudio}
      onDropTargetPreviewImage={onDropTargetPreviewImage}
      onClickUpdate={onClickUpdate}
      onClickSubmit={onClickSubmit}
      onChangeMarkerBased={onChangeMarkerBased}
      onGeoLocation={onGeoLocation}
      onDeleteMarker={onDeleteMarker}
      onUnitySaveClicked={onUnitySaveClicked}
    />
  )
}

export default withTranslation('')(ARUploads)
